import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faCheck, faEye, faEdit, faTrash, faEllipsisH, faCog, faThLarge, faList } from "@fortawesome/free-solid-svg-icons";
import MobileManageBoard from '../ManageBoard/MobileManageBoard';
import MobileFloatingActions from './MobileFloatingActions';
import MobileDetailView from './MobileDetailView';
import MobileEditForm from './MobileEditForm';

// 뷰 전환 바
const ViewToggleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 4px;
  margin-bottom: 8px;
  gap: 4px;
`;

const ViewToggleButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: ${props => props.$active ? '#0095f6' : '#f0f0f0'};
  color: ${props => props.$active ? 'white' : '#8e8e8e'};
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

// 리스트 뷰 스타일
const ListContainer = styled.div`
  background: white;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  overflow: hidden;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s;
  gap: 12px;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background: #f5f5f5;
  }

  ${props => props.$selected && `
    background: #ebf5ff;
    border-left: 3px solid #0095f6;
    padding-left: 11px;
  `}
`;

const ListItemCheckbox = styled.input`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
`;

const ListItemContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ListItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ListItemDescription = styled.div`
  font-size: 12px;
  color: #8e8e8e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const ListItemMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const ListItemMetaTag = styled.span`
  font-size: 11px;
  color: #8e8e8e;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ListItemDate = styled.span`
  font-size: 11px;
  color: #b0b0b0;
  flex-shrink: 0;
`;

const ListItemArrow = styled.div`
  color: #ccc;
  font-size: 14px;
  flex-shrink: 0;
`;

// Instagram 스타일 피드 컨테이너
const MobileContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0;
  background: #fafafa;
  padding: 0 12px;
`;

const FeedCard = styled.div`
  background: white;
  border: 1px solid #dbdbdb;
  margin: 0 0 12px 0;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  
  ${props => props.selected && `
    border: 2px solid #0095f6;
  `}
`;

const FeedHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #efefef;
`;

const FeedUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FeedAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
`;

const FeedUsername = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: #262626;
  text-align: left;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MobileCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const FeedContent = styled.div`
  padding: 0;
`;

const FeedMainInfo = styled.div`
  background: #f8f8f8;
  padding: 12px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
`;

const FeedActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #efefef;
`;

const FeedActionButtons = styled.div`
  display: flex;
  gap: 16px;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 24px;
  color: #262626;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const FeedDetails = styled.div`
  padding: 0 16px 16px;
`;

const FeedField = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  
  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const FeedFieldLabel = styled.span`
  font-weight: 600;
  color: #262626;
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 8px;
  min-width: fit-content;
`;

const FeedFieldValue = styled.div`
  color: #8e8e8e;
  text-align: right;
  flex: 1;
  word-break: break-word;
  
  input, select, textarea {
    width: 100%;
    padding: 6px;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #0095f6;
    }
  }
`;

const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: #0095f6;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  width: 100%;
  text-align: center;
  
  &:hover {
    color: #00376b;
  }
`;

const FloatingSettingsButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #007bff;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
  z-index: 999;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const SelectAllBar = styled.div`
  background: #f8f9fa;
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  border-radius: 6px;
`;

const SelectAllLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: white;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  margin: 20px 0;
`;

const PaginationButton = styled.button`
  padding: 8px 16px;
  background: ${props => props.disabled ? '#f0f0f0' : '#0095f6'};
  color: ${props => props.disabled ? '#999' : 'white'};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  
  &:hover:not(:disabled) {
    background: #00376b;
  }
`;

const PageInfo = styled.div`
  font-size: 14px;
  color: #262626;
  font-weight: 500;
`;

const LoadingMore = styled.div`
  text-align: center;
  padding: 20px;
  color: #8e8e8e;
  font-size: 14px;
`;

const LoadModeToggle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 15px 0;
  font-size: 13px;
  
  label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }
  
  input[type="radio"] {
    cursor: pointer;
  }
  
  select {
    padding: 4px 8px;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    font-size: 13px;
  }
`;

const LoadMoreButton = styled.button`
  width: calc(100% - 24px);
  margin: 20px 12px;
  padding: 15px;
  background: white;
  border: 2px solid #0095f6;
  color: #0095f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #0095f6;
    color: white;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const PageNumbers = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const PageNumber = styled.button`
  min-width: 36px;
  height: 36px;
  padding: 6px;
  background: ${props => props.active ? '#0095f6' : 'white'};
  color: ${props => props.active ? 'white' : '#262626'};
  border: 1px solid ${props => props.active ? '#0095f6' : '#dbdbdb'};
  border-radius: 6px;
  font-size: 14px;
  font-weight: ${props => props.active ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover:not(:disabled) {
    background: ${props => props.active ? '#00376b' : '#f0f0f0'};
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const MobileBoardTable = ({
  boards = [],
  columns = [],
  selectedRows = [],
  toggleRowSelection,
  isEditMode,
  editedRows = {},
  handleRowChange,
  setIsOpenViewer,
  setOpenPost,
  codeDisplayMap = {},
  isAllSelected,
  setIsAllSelected,
  tableName,
  onRefresh,
  setSelectedRows,
  setIsShowDynamicPopup,
  isOpenViewer,
  refreshFlag,
  setRefreshFlag,
  searchParams,
  setPopupType,
  saveMessage,
  handleButtonClick,
  values = {},
  setValues = () => {},
  menuConfig = {},
  setMenuConfig = () => {},
  // 서버 페이징 관련 props
  totalPosts = 0,
  currentPage = 1,
  postsPerPage = 20,
  onPageChange
}) => {
  const [viewMode, setViewMode] = useState('feed'); // 'feed' | 'list'
  const [expandedCards, setExpandedCards] = useState({});
  const [isManageBoardOpen, setIsManageBoardOpen] = useState(false);
  const [expandedContent, setExpandedContent] = useState({}); // 본문 확장 상태 관리
  const [detailViewOpen, setDetailViewOpen] = useState(false);
  const [editFormOpen, setEditFormOpen] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);

  // 데이터 로그 확인
  useEffect(() => {
    console.log('MobileBoardTable - boards length:', boards?.length || 0);
    console.log('MobileBoardTable - columns length:', columns?.length || 0);
    console.log('MobileBoardTable - menuConfig:', menuConfig);
    console.log('MobileBoardTable - display_title:', menuConfig?.display_title);
    console.log('MobileBoardTable - display_content:', menuConfig?.display_content);
    
    if (boards && boards.length > 0) {
      console.log('First board item:', boards[0]);
    }
    if (columns && columns.length > 0) {
      console.log('Visible columns:', columns.filter(col => col.cell_visible));
      console.log('Title column:', columns.find(col => col.column_id === menuConfig?.display_title));
      console.log('Content column:', columns.find(col => col.column_id === menuConfig?.display_content));
      console.log('Author column:', columns.find(col => col.column_id === 'author'));
    }
  }, [boards, columns, menuConfig]);

  // 서버 페이징으로 변경 - 모든 boards 데이터 표시 (서버에서 페이징 처리됨)
  const displayedBoards = boards;
  
  // 총 페이지 수 계산
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  
  // 페이지 번호 배열 생성 (모바일에서는 최대 5개만 표시)
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  // menuConfig에서 설정한 타이틀과 컨텐츠 컬럼 찾기
  const getTitleColumn = () => {
    if (menuConfig.display_title) {
      return columns.find(col => col.column_id === menuConfig.display_title);
    }
    // 설정이 없으면 첫 번째 visible 컬럼을 타이틀로 사용
    return columns.filter(col => col.cell_visible)[0];
  };

  const getContentColumn = () => {
    if (menuConfig.display_content) {
      return columns.find(col => col.column_id === menuConfig.display_content);
    }
    // 설정이 없으면 두 번째 visible 컬럼을 컨텐츠로 사용
    return columns.filter(col => col.cell_visible)[1];
  };

  // 작성자 컬럼 찾기 (author 컬럼 사용)
  const getAuthorColumn = () => {
    return columns.find(c => c.column_id === 'author');
  };

  // 작성시간 컬럼 찾기 (control_type이 DateTimeBox나 DateBox인 컬럼 우선)
  const getDateColumn = () => {
    // DateTimeBox나 DateBox 타입인 컬럼 먼저 찾기
    const dateCol = columns.find(c => 
      (c.control_type === 'DateTimeBox' || c.control_type === 'DateBox') && 
      c.cell_visible
    );
    if (dateCol) return dateCol;
    
    // 없으면 column_id로 찾기
    const dateColumns = ['created_at', 'reg_date', 'reg_datetime', 'date', 'datetime', 'timestamp'];
    for (const colId of dateColumns) {
      const col = columns.find(c => c.column_id === colId && c.cell_visible);
      if (col) return col;
    }
    // 못 찾으면 null 반환
    return null;
  };

  // 나머지 컬럼들 (타이틀, 컨텐츠, 작성자, 날짜를 제외한 컬럼들)
  const getSecondaryColumns = () => {
    const titleCol = getTitleColumn();
    const contentCol = getContentColumn();
    const authorCol = getAuthorColumn();
    const dateCol = getDateColumn();
    
    const excludeIds = [
      titleCol?.column_id,
      contentCol?.column_id,
      authorCol?.column_id,
      dateCol?.column_id
    ].filter(Boolean);
    
    return columns
      .filter(col => col.cell_visible && !excludeIds.includes(col.column_id))
      .sort((a, b) => (a.column_idx || 0) - (b.column_idx || 0));
  };
  
  // 카드 확장/축소 토글
  const toggleCardExpansion = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // 본문 내용 확장/축소 토글
  const toggleContentExpansion = (index) => {
    setExpandedContent(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // 텍스트를 제한된 길이로 자르는 함수
  const truncateText = (text, maxLength = 500) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const renderFieldValue = (column, board, index) => {
    if (!column || !board) {
      console.log('Missing column or board:', { column, board });
      return '-';
    }
    
    const isRowSelected = selectedRows.includes(index);
    const rawValue = editedRows[index]?.[column.column_id] ?? board[column.column_id];

    // 간단한 렌더링만 구현 (복잡한 컨트롤은 제외)
    switch (column.control_type) {
      case "CheckBox":
        return (
          <input
            type="checkbox"
            checked={rawValue === "true" || rawValue === true}
            onChange={(e) => isRowSelected && handleRowChange(index, column.column_id, e.target.checked, board)}
            disabled={!isRowSelected || column.read_only}
            style={{ width: '16px', height: '16px' }}
          />
        );
      
      case "DateBox":
      case "DateTimeBox":
        if (isRowSelected && !column.read_only) {
          return (
            <input
              type={column.control_type === "DateBox" ? "date" : "datetime-local"}
              value={rawValue || ""}
              onChange={(e) => handleRowChange(index, column.column_id, e.target.value, board)}
            />
          );
        }
        return <span>{rawValue || "-"}</span>;
      
      case "TextareaBox":
        if (isRowSelected && !column.read_only) {
          return (
            <textarea
              value={rawValue || ""}
              onChange={(e) => handleRowChange(index, column.column_id, e.target.value, board)}
              rows="2"
            />
          );
        }
        return <span>{rawValue || "-"}</span>;

      case "Button":
        return (
          <ActionButton disabled={isEditMode}>
            {column.column_title}
          </ActionButton>
        );

      default:
        // 기본 텍스트 입력 또는 표시
        if (isRowSelected && !column.read_only) {
          return (
            <input
              type="text"
              value={rawValue || ""}
              onChange={(e) => handleRowChange(index, column.column_id, e.target.value, board)}
            />
          );
        }

        // 표시 값 처리
        let displayValue = rawValue;
        
        // 코드 매핑 처리
        if (["S", "M", "C"].includes(column.bind_type) && codeDisplayMap[column.bind_key]) {
          displayValue = codeDisplayMap[column.bind_key][rawValue] || rawValue;
        }
        
        // 마스크 처리
        if (column.mask === "PriceNum") {
          displayValue = displayValue ? displayValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
        } else if (column.mask === "Files") {
          return rawValue ? <FontAwesomeIcon icon={faPaperclip} style={{ color: '#4fc3f7' }} /> : "-";
        }

        return <span>{displayValue || "-"}</span>;
    }
  };

  const handleCardClick = (board, index) => {
    setSelectedBoard(board);
    setDetailViewOpen(true);
    
    // 기존 뷰어도 닫기
    if (setIsOpenViewer) {
      setIsOpenViewer(false);
    }
  };

  const handleEditClick = (board, index) => {
    setSelectedBoard(board);
    setEditFormOpen(true);
  };

  const handleDeleteClick = (board, index) => {
    if (window.confirm('이 항목을 삭제하시겠습니까?')) {
      console.log('삭제:', board);
      // 실제 삭제 API 호출 로직 추가 필요
      // onDelete 콜백이 있다면 호출
      if (onRefresh) {
        onRefresh(); // 삭제 후 목록 새로고침
      }
    }
  };

  const handleSave = async (editData) => {
    console.log('저장:', editData);
    // 실제 저장 API 호출 로직 추가 필요
    // 저장 성공 후 목록 새로고침
    if (onRefresh) {
      onRefresh();
    }
  };
  
  const handleSelectAll = (e) => {
    if (setIsAllSelected) {
      setIsAllSelected(e.target.checked);
    }
    if (e.target.checked) {
      boards.forEach((_, index) => {
        if (toggleRowSelection) {
          toggleRowSelection(index, boards[index], true);
        }
      });
    } else {
      boards.forEach((_, index) => {
        if (toggleRowSelection) {
          toggleRowSelection(index, boards[index], false);
        }
      });
    }
  };

  // ManageBoard 토글 핸들러
  const toggleManageBoard = () => {
    setIsManageBoardOpen(!isManageBoardOpen);
  };

  // 플로팅 액션 핸들러들
  const handleNewPost = () => {
    console.log('신규 등록');
    // 신규 등록 로직 구현
  };

  const handleEdit = () => {
    console.log('수정:', selectedRows.length, '개 항목');
    // 수정 로직 구현
  };

  const handleDelete = () => {
    if (window.confirm(`선택한 ${selectedRows.length}개 항목을 삭제하시겠습니까?`)) {
      console.log('삭제:', selectedRows);
      // 삭제 로직 구현
    }
  };

  const handleExcelDownload = () => {
    console.log('엑셀 다운로드');
    // 엑셀 다운로드 로직 구현
  };

  const handleUpload = () => {
    console.log('업로드');
    // 업로드 로직 구현
  };

  // 리스트 뷰에서 표시할 메타 컬럼 (타이틀/작성자/날짜 제외한 중요 컬럼 최대 3개)
  const getListMetaColumns = () => {
    const titleCol = getTitleColumn();
    const authorCol = getAuthorColumn();
    const dateCol = getDateColumn();
    const contentCol = getContentColumn();

    const excludeIds = [
      titleCol?.column_id,
      authorCol?.column_id,
      dateCol?.column_id,
      contentCol?.column_id
    ].filter(Boolean);

    return columns
      .filter(col => col.cell_visible && !excludeIds.includes(col.column_id))
      .sort((a, b) => (a.column_idx || 0) - (b.column_idx || 0))
      .slice(0, 3);
  };

  // 리스트 뷰에서 값 표시
  const getDisplayValue = (column, board) => {
    if (!column || !board) return '-';
    const rawValue = board[column.column_id];
    if (!rawValue) return '-';

    // 코드 매핑
    if (["S", "M", "C"].includes(column.bind_type) && codeDisplayMap[column.bind_key]) {
      return codeDisplayMap[column.bind_key][rawValue] || rawValue;
    }

    // 마스크
    if (column.mask === "PriceNum") {
      return rawValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else if (column.mask === "Files") {
      return '📎';
    }

    return rawValue;
  };

  // 리스트 뷰 렌더링
  const renderListView = () => {
    const titleColumn = getTitleColumn();
    const contentColumn = getContentColumn();
    const authorColumn = getAuthorColumn();
    const dateColumn = getDateColumn();
    const metaColumns = getListMetaColumns();

    const formatDate = (dateValue) => {
      if (!dateValue) return '';
      const date = new Date(dateValue);
      const now = new Date();
      const diff = now - date;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff / (1000 * 60));

      if (days > 7) return date.toLocaleDateString('ko-KR');
      if (days > 0) return `${days}일 전`;
      if (hours > 0) return `${hours}시간 전`;
      if (minutes > 0) return `${minutes}분 전`;
      return '방금 전';
    };

    return (
      <ListContainer>
        {displayedBoards.map((board, index) => {
          const isSelected = selectedRows.includes(index);
          const titleValue = titleColumn ? board[titleColumn.column_id] : `아이템 ${index + 1}`;
          const contentValue = contentColumn ? board[contentColumn.column_id] : null;
          const authorValue = authorColumn ? board[authorColumn.column_id] : null;
          const dateValue = dateColumn ? board[dateColumn.column_id] : null;

          return (
            <ListItem
              key={index}
              $selected={isSelected}
              onClick={() => handleCardClick(board, index)}
            >
              <ListItemCheckbox
                type="checkbox"
                checked={isSelected}
                onChange={(e) => {
                  e.stopPropagation();
                  toggleRowSelection && toggleRowSelection(index, board);
                }}
              />
              <ListItemContent>
                <ListItemTitle>{titleValue || '-'}</ListItemTitle>
                {contentValue && (
                  <ListItemDescription>
                    {String(contentValue).replace(/<[^>]*>/g, '')}
                  </ListItemDescription>
                )}
                <ListItemMeta>
                  {authorValue && (
                    <ListItemMetaTag>{authorValue}</ListItemMetaTag>
                  )}
                  {metaColumns.map((col) => {
                    const val = getDisplayValue(col, board);
                    if (!val || val === '-') return null;
                    return (
                      <ListItemMetaTag key={col.column_id} title={`${col.mapping_name || col.column_title}: ${val}`}>
                        {val}
                      </ListItemMetaTag>
                    );
                  })}
                </ListItemMeta>
              </ListItemContent>
              {dateValue && (
                <ListItemDate>{formatDate(dateValue)}</ListItemDate>
              )}
              <ListItemArrow>›</ListItemArrow>
            </ListItem>
          );
        })}
      </ListContainer>
    );
  };

  return (
    <MobileContainer>

      {/* 뷰 전환 토글 */}
      {boards && boards.length > 0 && (
        <ViewToggleBar>
          <ViewToggleButton
            $active={viewMode === 'feed'}
            onClick={() => setViewMode('feed')}
            title="피드 뷰"
          >
            <FontAwesomeIcon icon={faThLarge} />
          </ViewToggleButton>
          <ViewToggleButton
            $active={viewMode === 'list'}
            onClick={() => setViewMode('list')}
            title="리스트 뷰"
          >
            <FontAwesomeIcon icon={faList} />
          </ViewToggleButton>
        </ViewToggleBar>
      )}

      {/* 데이터가 없을 때 */}
      {(!boards || boards.length === 0) ? (
        <FeedCard style={{ padding: '40px', textAlign: 'center' }}>
          <span style={{ color: '#8e8e8e', fontSize: '14px' }}>
            표시할 데이터가 없습니다.
          </span>
        </FeedCard>
      ) : viewMode === 'list' ? (
        <>
          {renderListView()}

          {/* 페이지네이션 */}
          {totalPages > 1 && (
            <PaginationContainer>
              <PaginationButton
                onClick={() => onPageChange && onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                이전
              </PaginationButton>
              <PageNumbers>
                {getPageNumbers().map(pageNum => (
                  <PageNumber
                    key={pageNum}
                    active={pageNum === currentPage}
                    onClick={() => onPageChange && onPageChange(pageNum)}
                  >
                    {pageNum}
                  </PageNumber>
                ))}
              </PageNumbers>
              <PaginationButton
                onClick={() => onPageChange && onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                다음
              </PaginationButton>
            </PaginationContainer>
          )}

          {boards.length > 0 && (
            <div style={{ textAlign: 'center', padding: '10px', color: '#8e8e8e', fontSize: '13px' }}>
              페이지 {currentPage}/{totalPages} (전체 {totalPosts}개)
            </div>
          )}
        </>
      ) : (
        <>
        {/* Instagram 스타일 피드 카드 */}
        {displayedBoards.map((board, index) => {
          const isSelected = selectedRows.includes(index);
          const isExpanded = expandedCards[index];
          
          // 설정된 컬럼들 가져오기
          const titleColumn = getTitleColumn();
          const contentColumn = getContentColumn();
          const authorColumn = getAuthorColumn();
          const dateColumn = getDateColumn();
          const secondaryColumns = getSecondaryColumns();
          
          // 작성자 정보를 아바타 이니셜로 사용
          const authorValue = authorColumn ? board[authorColumn.column_id] : null;
          const avatarInitial = authorValue ? String(authorValue).charAt(0).toUpperCase() : 'U';
          
          // 타이틀 값 가져오기
          const titleValue = titleColumn ? board[titleColumn.column_id] : `아이템 ${index + 1}`;
          
          // 날짜 포맷팅 헬퍼 함수
          const formatDate = (dateValue) => {
            if (!dateValue) return '';
            const date = new Date(dateValue);
            const now = new Date();
            const diff = now - date;
            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            
            if (days > 7) {
              return date.toLocaleDateString('ko-KR');
            } else if (days > 0) {
              return `${days}일 전`;
            } else if (hours > 0) {
              return `${hours}시간 전`;
            } else if (minutes > 0) {
              return `${minutes}분 전`;
            } else {
              return '방금 전';
            }
          };

          return (
            <FeedCard 
              key={index} 
              selected={isSelected}
              onDoubleClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCardClick(board, index);
              }}
            >
              {/* 헤더 영역 */}
              <FeedHeader>
                <FeedUserInfo>
                  <FeedAvatar>{avatarInitial}</FeedAvatar>
                  <div>
                    <FeedUsername>
                      {authorValue || '작성자 없음'}
                    </FeedUsername>
                    <div style={{ fontSize: '12px', color: '#8e8e8e' }}>
                      {dateColumn ? formatDate(board[dateColumn.column_id]) : ''}
                    </div>
                  </div>
                </FeedUserInfo>
                <MobileCheckbox
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => toggleRowSelection && toggleRowSelection(index, board)}
                />
              </FeedHeader>

              {/* 메인 콘텐츠 영역 */}
              <FeedContent>
                <FeedMainInfo>
                  {/* 타이틀 표시 */}
                  {titleColumn && (
                    <div style={{ 
                      fontSize: '16px', 
                      fontWeight: '600',
                      color: '#262626',
                      marginBottom: '8px',
                      lineHeight: '1.3'
                    }}>
                      {titleValue}
                    </div>
                  )}
                  
                  {/* 컨텐츠 표시 */}
                  {contentColumn && (
                    <div 
                      style={{ 
                        fontSize: '14px', 
                        lineHeight: '1.5', 
                        color: '#666',
                        marginBottom: '12px',
                        wordWrap: 'break-word',
                        maxWidth: '100%',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        const content = board[contentColumn.column_id];
                        if (content && content.length > 500) {
                          toggleContentExpansion(index);
                        }
                      }}
                    >
                      {(() => {
                        const content = board[contentColumn.column_id] || '';
                        const isExpanded = expandedContent[index];
                        
                        if (content.length <= 500) {
                          return content; // 짧은 내용은 그대로 표시
                        }
                        
                        return isExpanded ? (
                          <>
                            {content}
                            <span style={{ color: '#0095f6', fontWeight: '600', marginLeft: '8px' }}>
                              접기
                            </span>
                          </>
                        ) : (
                          <>
                            {truncateText(content, 500)}
                            <span style={{ color: '#0095f6', fontWeight: '600', marginLeft: '8px' }}>
                              더보기
                            </span>
                          </>
                        );
                      })()}
                    </div>
                  )}
                  
                  {/* 나머지 중요 컬럼들을 간단하게 표시 (최대 2개) */}
                  {secondaryColumns.slice(0, 2).map((column) => (
                    <FeedField key={column.column_id} style={{ padding: '4px 0' }}>
                      <FeedFieldLabel style={{ fontSize: '12px', color: '#8e8e8e' }}>
                        {column.mapping_name || column.column_title}
                      </FeedFieldLabel>
                      <FeedFieldValue style={{ fontSize: '12px' }}>
                        {renderFieldValue(column, board, index)}
                      </FeedFieldValue>
                    </FeedField>
                  ))}
                </FeedMainInfo>
              </FeedContent>

              {/* 액션 버튼들 */}
              <FeedActions>
                <FeedActionButtons>
                  <ActionButton 
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCardClick(board, index);
                    }}
                    title="상세보기"
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </ActionButton>
                  <ActionButton 
                    onClick={() => handleEditClick(board, index)}
                    title="수정"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </ActionButton>
                  <ActionButton 
                    onClick={() => handleDeleteClick(board, index)}
                    title="삭제"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </ActionButton>
                </FeedActionButtons>
              </FeedActions>

              {/* 확장 가능한 상세 정보 - 나머지 컬럼들 약식 표시 */}
              {secondaryColumns.length > 2 && (
                <>
                  {isExpanded && (
                    <FeedDetails>
                      {/* 처음 2개는 이미 위에 표시했으므로 3번째부터 표시 */}
                      {secondaryColumns.slice(2).map((column) => (
                        <FeedField key={column.column_id} style={{ padding: '6px 0' }}>
                          <FeedFieldLabel style={{ fontSize: '13px', flex: '0 0 35%' }}>
                            {column.mapping_name || column.column_title}
                          </FeedFieldLabel>
                          <FeedFieldValue style={{ fontSize: '13px', color: '#666' }}>
                            {renderFieldValue(column, board, index)}
                          </FeedFieldValue>
                        </FeedField>
                      ))}
                    </FeedDetails>
                  )}
                  <ShowMoreButton onClick={() => toggleCardExpansion(index)}>
                    {isExpanded ? '접기' : `더보기 (${secondaryColumns.length - 2}개 항목)`}
                  </ShowMoreButton>
                </>
              )}
            </FeedCard>
          );
        })}
        
        {/* 페이지네이션 */}
        {totalPages > 1 && (
          <PaginationContainer>
            {/* 이전 버튼 */}
            <PaginationButton 
              onClick={() => onPageChange && onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              이전
            </PaginationButton>
            
            {/* 페이지 번호들 */}
            <PageNumbers>
              {getPageNumbers().map(pageNum => (
                <PageNumber 
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => onPageChange && onPageChange(pageNum)}
                >
                  {pageNum}
                </PageNumber>
              ))}
            </PageNumbers>
            
            {/* 다음 버튼 */}
            <PaginationButton 
              onClick={() => onPageChange && onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              다음
            </PaginationButton>
          </PaginationContainer>
        )}
        
        {/* 전체 개수 표시 */}
        {boards.length > 0 && (
          <div style={{ 
            textAlign: 'center', 
            padding: '10px', 
            color: '#8e8e8e',
            fontSize: '13px'
          }}>
            페이지 {currentPage}/{totalPages} (전체 {totalPosts}개)
          </div>
        )}
        </>
      )}
      
      {/* 저장 메시지 */}
      {saveMessage && (
        <div style={{ textAlign: 'center', padding: '10px', color: '#4caf50' }}>
          {saveMessage}
        </div>
      )}

      {/* 플로팅 액션 버튼들 */}
      <MobileFloatingActions
        menuConfig={menuConfig}
        selectedRows={selectedRows}
        onNewPost={handleNewPost}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onExcelDownload={handleExcelDownload}
        onUpload={handleUpload}
        onSettings={toggleManageBoard}
      />

      {/* 모바일 ManageBoard 설정 */}
      {isManageBoardOpen && (
        <MobileManageBoard
          tableName={tableName}
          values={values}
          setValues={setValues}
          menuConfig={menuConfig}
          setMenuConfig={setMenuConfig}
          onClose={toggleManageBoard}
        />
      )}

      {/* 상세보기 팝업 */}
      <MobileDetailView
        isOpen={detailViewOpen}
        onClose={() => setDetailViewOpen(false)}
        board={selectedBoard}
        columns={columns}
        codeDisplayMap={codeDisplayMap}
      />

      {/* 수정 팝업 */}
      <MobileEditForm
        isOpen={editFormOpen}
        onClose={() => setEditFormOpen(false)}
        board={selectedBoard}
        columns={columns}
        codeDisplayMap={codeDisplayMap}
        onSave={handleSave}
      />
    </MobileContainer>
  );
};

export default MobileBoardTable;
export { MobileBoardTable };